import './styles.scss';
import { useState } from 'react';
import treatmentsImage from '../../assets/treatments-image.jpg'
import redIdentity from '../../assets/red-identity.png'

function Treatments() {

    const [treatment, setTreatment] = useState(0);
    const [showTreatment, setShowTreatment] = useState(false);


    const handleTreatment = (id) => {
        if (treatment === id) {
            setShowTreatment(!showTreatment);
        } else {
            setTreatment(id);
            setShowTreatment(true);
        }
    };

    return (
        <div id="treatments-section" className="container-treatments">
            <div className='treatments-left'>
                <img src={treatmentsImage} alt='Dra. Lais' />
            </div>
            <div className='treatments-right'>
                <h1 onClick={() => handleTreatment(null)}>Tratamentos Oferecidos</h1>
                <p onClick={() => handleTreatment(null)} >Cuidar das suas pernas é também cuidar da sua autoestima, do seu bem-estar e da sua liberdade. Aqui, você encontra escuta, segurança e um plano individualizado, feito para sua realidade. Conheça os principais tratamentos que podem transformar a sua rotina:</p>
                <div className='treatments-content'>
                    <ul>
                        <li>
                            <h4 onClick={() => handleTreatment(1)}><i className={`fas ${showTreatment && treatment === 1 ? "fa-minus-circle" : "fa-plus-circle"} ml-2 float-right text-custom-2`}></i>Microcirurgia de Varizes</h4>
                            {treatment === 1 && showTreatment &&
                                <p><i className="fa-solid fa-angles-right"></i>Procedimento minimamente invasivo que consiste na retirada de veias doentes através de um pequeno furo na pele. Este procedimento pode ser realizado com anestesia local e uma sedação leve. Por conta do tamanho mínimo dos cortes (microincisões), não há necessidade de pontos, geralmente não deixam cicatrizes e o paciente recebe alta no mesmo dia.</p>}
                        </li>

                        <li>
                            <h4 onClick={() => handleTreatment(2)}><i className={`fas ${showTreatment && treatment === 2 ? "fa-minus-circle" : "fa-plus-circle"} ml-2 float-right text-custom-2`}></i>Escleroterapia</h4>
                            {treatment === 2 && showTreatment &&
                                <p><i className="fa-solid fa-angles-right"></i>Técnica para tratamento de vasinhos, realizada  através da injeção de substância esclerosante nos vasinhos utilizando agulhas bem finas. Ela melhora a aparência dos vasinhos e alivia desconfortos, é um procedimento realizado em consultório.</p>}
                        </li>
                        <li>
                            <h4 onClick={() => handleTreatment(3)}><i className={`fas ${showTreatment && treatment === 3 ? "fa-minus-circle" : "fa-plus-circle"} ml-2 float-right text-custom-2`}></i>Espuma</h4>
                            {treatment === 3 && showTreatment &&
                                <p><i className="fa-solid fa-angles-right"></i>Técnica muito útil, com injeção de medicamento diretamente nas varizes de grande e médio calibre. É um procedimento seguro, feito em consultório guiado por ultrassom.</p>}
                        </li>
                        <li>
                            <h4 onClick={() => handleTreatment(4)}><i className={`fas ${showTreatment && treatment === 4 ? "fa-minus-circle" : "fa-plus-circle"} ml-2 float-right text-custom-2`}></i>Laser transdérmico</h4>
                            {treatment === 4 && showTreatment &&
                                <p><i className="fa-solid fa-angles-right"></i>Método moderno que consiste no disparo de energia através de um aparelho especial para tratar as varizes através da ação térmica.É realizado em consultório, sem a necessidade de repouso e com algumas técnicas para alívio da dor.</p>}
                        </li>
                        <li>
                            <h4 onClick={() => handleTreatment(5)}><i className={`fas ${showTreatment && treatment === 5 ? "fa-minus-circle" : "fa-plus-circle"} ml-2 float-right text-custom-2`}></i>Tratamento de veia safena</h4>
                            {treatment === 5 && showTreatment &&
                                <p><i className="fa-solid fa-angles-right"></i>A depender do caso, pode ser feito por cirurgia convencional ou por Endolaser — técnica considerada "padrão ouro". É realizado em ambiente equipado, mas sem necessidade de longo internamento, com menos dor, menos hematomas e com retorno precoce as atividades.</p>}
                        </li>
                    </ul>

                </div>

            </div>
            <img className="treatments-identity" src={redIdentity} alt="DLM" />

        </div>
    );
}

export default Treatments;
